/**
 * Pending partnership requests for My Workspaces (Dashboard.jsx).
 *
 * Only pending requests show here — a client genuinely needs to act on
 * those without entering a workspace. The active partner (with remove) now
 * lives on the Profile page instead, between the Profile and My Apps
 * sections, alongside other account-level relationships. "Become a
 * Partner" lives in the header next to Admin/Partner.
 */
import React, { useState } from 'react';
import { useApi } from '../lib/api';

export default function PartnershipCard({
  isPartner,
  pendingLinks,
  onRefresh,
  onError,
}) {
  const api = useApi();
  const [busyId, setBusyId] = useState(null);

  const handleAccept = async (id) => {
    setBusyId(id);
    try {
      await api.acceptPartnerLink(id);
      onRefresh?.();
    } catch (err) {
      onError?.(err.response?.data?.error || err.message || 'Failed to accept');
    } finally {
      setBusyId(null);
    }
  };

  const handleDecline = async (id) => {
    setBusyId(`decline-${id}`);
    try {
      await api.declinePartnerLink(id);
      onRefresh?.();
    } catch (err) {
      onError?.(err.response?.data?.error || err.message || 'Failed to decline');
    } finally {
      setBusyId(null);
    }
  };

  if (isPartner) return null;
  if (!pendingLinks || pendingLinks.length === 0) return null;

  return (
    <section className="invitations-panel">
      <h2 className="section-title">
        Partnership Request{pendingLinks.length > 1 ? 's' : ''}{' '}
        <span className="badge-count">{pendingLinks.length}</span>
      </h2>
      <div className="invitations-list">
        {pendingLinks.map((link) => (
          <div key={link.id} className="invitation-row">
            <div className="invitation-meta">
              <p className="invitation-app">
                <strong>{link.partner_name}</strong> wants to partner with you.
              </p>
            </div>
            <div className="invitation-actions">
              <button
                className="btn-primary"
                onClick={() => handleAccept(link.id)}
                disabled={busyId === link.id || busyId === `decline-${link.id}`}
              >
                {busyId === link.id ? 'Accepting…' : 'Accept'}
              </button>
              <button
                className="btn-secondary"
                onClick={() => handleDecline(link.id)}
                disabled={busyId === link.id || busyId === `decline-${link.id}`}
              >
                {busyId === `decline-${link.id}` ? 'Declining…' : 'Decline'}
              </button>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
